/** The icon profile */
const IconProfile = (): React.ReactElement => {
  return (
    <>
      <g clipPath="url(#clip0_13656_40894)" data-icon="icon-profile">
        <circle
          cx="50%"
          cy="10"
          r="5"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
        <circle
          cx="50%"
          cy="28"
          r="12"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
      </g>

      <defs>
        <clipPath id="clip0_13656_40894">
          <rect width="24" height="20" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};

export default IconProfile;
